import companies from './companies'

export default [
  {
    company: companies.Sanddev,
    title: 'Senior Full-Stack Engineer',
    date: 'April 2023 - October 2026',
    tech: 'TypeScript, React, AI agents'
  },
  {
    company: companies.PGS,
    title: 'Omio, Nate, Sage',
    date: 'July 2021 - March 2023',
    tech: 'TypeScript, React, React Native'
  },
  {
    company: companies.Sandstream,
    title: 'Full-Stack Developer',
    date: 'July 2017 - June 2021',
    tech: 'React, Redux, C#, .NET'
  },
  {
    company: companies.SelfEmployment,
    title: '25+ apps, 3.7 million+ downloads',
    date: '2012 - July 2017',
    tech: 'C#, XAML, ASP.NET'
  },
  {
    company: companies.LOSO,
    title: 'RatingSpeed',
    date: 'September - October 2014',
    scope: 'Windows Phone app',
    tech: 'C#, XAML',
    classes: { 'media-no-print': true }
  },
  {
    company: companies.IT4Biznes,
    title: 'Fast-coffee',
    date: 'August - September 2014',
    scope: 'Windows Phone app',
    tech: 'C#, XAML',
    classes: { 'media-no-print': true }
  },
  {
    company: companies.CubeInvestments,
    date: 'February - March 2013',
    title: 'Kwejk.pl',
    scope: 'Windows Phone app',
    tech: 'C#, XAML',
    classes: { 'media-no-print': true }
  },
  {
    company: companies.RedDotGames,
    date: 'August 2010 - January 2011, November - December 2012',
    title: 'I Am Rich The Game',
    scope: 'Windows PC, Store app',
    tech: 'C++, C#, DirectX',
    classes: {
      'media-no-print': true
    }
  },
  {
    company: companies.RedDotGames,
    date: 'September - November 2009',
    title: 'Platformer game engine',
    scope: 'Windows PC, Xbox 360',
    tech: 'C#, XNA',
    classes: {
      'media-no-print': true
    }
  }
]
